/** Header, footer, and the CTAs that repeat across the marketing pages. */
export const SITE = {
  wordmark: "GoodSender",
  /*
   * Every entry is a page route, so every entry is a `Link` and stays
   * client-side. The "How it works" section-anchor entry (a `hash` field and
   * a matching branch in `_home.tsx`) was removed 2026-08-28; the dedicated
   * pages carry the story now. Resurrect both from history if an anchor
   * entry ever returns.
   */
  nav: [
    /*
     * Every entry is reachable at every width: the phone header folds the
     * whole list behind a menu button instead of dropping entries (the
     * per-entry `collapse` flag retired 2026-08-28 did the dropping).
     */
    { label: "Blog platform", to: "/ai-blogging-platform" },
    { label: "AI tools", to: "/agents" },
    { label: "Pricing", to: "/pricing" },
    /*
     * FAQ was footer-only until 2026-08-29. The copy cut that shortened the
     * three decks moved their supporting arguments (why deliverability lands,
     * what an agent can reach, what migrates) into the FAQ answers rather than
     * deleting them, so the page a skeptic needs stopped being reachable
     * without scrolling past the whole deck. Ordered after Pricing to match
     * `SiteFooter.tsx`'s list.
     */
    { label: "FAQ", to: "/faq" },
  ],
  /*
   * The /compare hub — footer-only, after the nav entries. The header stays
   * four entries; the footer is the sitewide link that lets crawlers reach the
   * hub and the `/compare/<slug>` articles it lists without the sitemap.
   */
  compare: { label: "Compare", to: "/compare" },
  ctaPrimary: "Start free",
  /*
   * The /agents hero's and the sub-pages' second CTA, pointing at /pricing:
   * those heroes quote no numbers (agent-first refocus, D-3), so this link is
   * where the price lives. The homepage also points at /pricing. The blog platform links to /agents;
   * its close uses `skill`.
   */
  ctaSecondary: "See what it costs",
  /*
   * The goodsender-blog skill: an optional workflow addition linked from
   * the landing's final close. External, so it renders as a plain anchor
   * rather than a `Link`.
   */
  skill: {
    label: "Get the skill",
    href: "https://github.com/good-sender/skills",
  },
  footer: {
    credibility: "Built by the team behind SendGrid and Laneful.",
    copyright: "© 2026 GoodSender by Joy Labs Ventures.",
  },
} as const;
